
<!--
  <h1 mat-dialog-title>{{ "PLANNER.reasonNonProgrammableOrders" | translate }}</h1>
-->
<div mat-dialog-content>

  <div *ngIf="projectCosts && projectCosts.length > 0" class="table-container">
    <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">

      <!-- Expenditure Date Column -->
      <ng-container matColumnDef="Expenditure_Date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Expenditure_Date" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Expenditure_Date }}</td>
      </ng-container>

      <!-- Item Number Column -->
      <ng-container matColumnDef="Item_Number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Item_Number" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Item_Number }}</td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Description" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <!-- Quantity Column -->
      <ng-container matColumnDef="Quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Quantity" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Quantity }}</td>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="Value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Value" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Value | number:'1.2-2' }}</td>
      </ng-container>

      <!-- Unit Of Measure Column -->
      <ng-container matColumnDef="Unit_Of_Measure">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Unit_Of_Measure" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Unit_Of_Measure }}</td>
      </ng-container>

      <!-- Currency Column -->
      <ng-container matColumnDef="Currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.Currency" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.Currency }}</td>
      </ng-container>

      <!-- Numero Documento Column -->
      <ng-container matColumnDef="NumeroDocumento">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "PROJECTCOSTS.NumeroDocumento" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.NumeroDocumento }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" 
                   [pageSize]="10"
                   showFirstLastButtons>
    </mat-paginator>
  </div>

  <div *ngIf="!projectCosts || projectCosts.length === 0">
    {{ "PROJECTCOSTS.no_data" | translate }}
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">{{ "LABEL.CANCEL" | translate }}</button>
</div>